module.exports = __webpack_public_path__ + "media/react-view-today@md-57c1e53aaafa0a295403b42114465514.jpg";